import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '@shared/components/error-dialog/error-dialog.component';


@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private isDialogOpen = false;

  constructor(private injector: Injector, private zone: NgZone) {}

  handleError(error: any): void {
    // Log to console so developers can see it
    console.error('Global Error Handler caught:', error);

    // Use injector to get MatDialog to avoid cyclic dependency issues during initialization
    // wrapped in a try-catch because if the error happens during app init, MatDialog might not be ready
    try {
      const dialog = this.injector.get(MatDialog);

      this.zone.run(() => {
        if (this.isDialogOpen) {
          return; // Prevent stacking dialogs
        }

        this.isDialogOpen = true;
        
        // Extract meaningful message
        const errorData = {
          error: error.message ? error : { message: error.toString() }, // Ensure object or wrap string
          component: 'Global Handler'
        };

        const dialogRef = dialog.open(ErrorDialogComponent, {
          data: errorData,
          width: '600px',
          disableClose: true // Force user to acknowledge or close explicitly
        });

        dialogRef.afterClosed().subscribe(() => {
          this.isDialogOpen = false;
        });
      });
    } catch (e) {
      console.warn('Unable to open Error Dialog (Service likely not ready):', e);
    }
  }
}
